
URL = globalThis.URL
import __vite__wasmUrl from "/Users/john/projects/outlaw/.claude/worktrees/release-7.0.x/src/practice/client/src/lib/payments/wasm/payments_wasm_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./payments_wasm_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./payments_wasm_bg.js": { "__wbg___wbindgen_throw_1506f2235d1bdba0": __vite__wasmImport_0["__wbg___wbindgen_throw_1506f2235d1bdba0"],
"__wbg_Error_ef53bc310eb298a0": __vite__wasmImport_0["__wbg_Error_ef53bc310eb298a0"],
"__wbindgen_init_externref_table": __vite__wasmImport_0["__wbindgen_init_externref_table"] } }, __vite__wasmUrl);
export const {
  memory,
  __wbg_allocationresult_free,
  allocateExpensesFirst,
  allocateExpensesFirstInFirstOut,
  allocateFirstInFirstOut,
  allocateProportional,
  allocationresult_allocated,
  allocationresult_indices,
  feeBasisPoints,
  moneyCheckedAdd,
  moneyCheckedMultiplyByScalar,
  moneyCheckedNegate,
  moneyCheckedSubtract,
  moneyCheckedSum,
  moneyRoundToCents,
  __wbindgen_externrefs,
  __wbindgen_malloc,
  __externref_table_dealloc,
  __wbindgen_free,
  __wbindgen_start,
} = __vite__wasmModule;
